/**
 * Contains all the methods needed for uibModalServices.
 * Should migrate all uib modal services when components migrated to angular
 */
var UibModalService = /** @class */ (function () {
    /*@ngInject*/
    function UibModalService($uibModal) {
        this.$uibModal = $uibModal;
    }
    // From company service
    // Add in company service when changed uibModal to NgbModal
    UibModalService.prototype.showAllCompanies = function () {
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-extra-small',
            component: 'companies',
            resolve: {}
        });
    };
    return UibModalService;
}());
export { UibModalService };
//# sourceMappingURL=uibModalService.js.map